module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DB7ptE/tc-custom/9781637414019.jpg?1716662258246",
      "alt": "This image is the cover for the book Lebanese Food"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lebanese Food\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Even fussy eaters will enjoy. . . . Close-up color photographs of finished dishes give the cook good guidance to how the product should appear when served.” —"), _c('i', [_vm._v("Booklist")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Strongly rooted in the culinary traditions of the Middle East and the Mediterranean, Lebanese food draws on the exotic tastes of these two styles. These delicious, easy-to-make dishes—abounding in vegetables, fruits, yogurt, grains, and pungent spices—also are ideal for the health-conscious diner. And the recipes--from the scrumptious salads to the grilled kebabs—come from an author who learned them right in her grandmother's and mother's kitchens. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cassie Maroun-Paladin, John Peacock\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    New Holland Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0